import { FC } from 'react'
import { observer } from 'mobx-react'
import { useTranslation } from 'next-i18next'
import { Field, Form, Formik } from 'formik'
import { IPublicUser, MessageType, UserNotificationType } from '../../../types'
import styles from './index.module.scss'
import { CloseButton } from '../../atoms/CloseButton'
import { useStores } from '../../../utils'
import { Button } from '../../atoms/Button'

type Props = {
  user: IPublicUser
  toggleModal: () => void
}

type Value = {
  notificationIds: string[]
}

// TODO: CompanyNotificationSettingsModal とリファクタ
export const UserNotificationSettingsModal: FC<Props> = observer(({ user, toggleModal }) => {
  const { t } = useTranslation(['p'])
  const { viewer, messages } = useStores()
  const initialValue: Value = {
    notificationIds: user.notificationSettings.map((notificationSetting) => notificationSetting.id),
  }

  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <h2 className={styles.headingText}>{t('通知の受け取り設定')}</h2>
        <div className={styles.closeButton}>
          <CloseButton onClick={toggleModal} />
        </div>
      </div>
      <Formik
        initialValues={initialValue}
        onSubmit={async (values: Value, actions) => {
          const newUser = await viewer.viewer.updateUserNotificationSettings(user.username, values.notificationIds)
          actions.setSubmitting(false)
          if (newUser) {
            user.update(newUser)
            messages.add({
              type: MessageType.Info,
              body: t('通知の受け取り設定を変更しました'),
              ttl: 5000,
            })
            toggleModal()
          }
        }}
      >
        {({ isSubmitting }) => (
          <Form>
            <div className={styles.content}>
              <label className={styles.label}>
                {t('求職活動に関する通知を受け取る')}
                <Field type='checkbox' name='notificationIds' value={UserNotificationType.JobSeekingStatusUpdated} />
              </label>
            </div>
            <div className={styles.buttonContainer}>
              <div>
                <Button
                  styleType='default'
                  componentType='button'
                  buttonType='submit'
                  buttonSize='small'
                  disabled={isSubmitting}
                  isLoading={isSubmitting}
                >
                  {t('完了')}
                </Button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
})
